/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptConfigurationsControllerFindOneQueryResponse, PromptConfigurationsControllerFindOnePathParams, PromptConfigurationsControllerFindOne401, PromptConfigurationsControllerFindOne403, PromptConfigurationsControllerFindOne404 } from "../../models/promptConfigurationsController/PromptConfigurationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { promptConfigurationsControllerFindOne } from "../../clients/prompt-configurationsService/promptConfigurationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const promptConfigurationsControllerFindOneQueryKey = (id: PromptConfigurationsControllerFindOnePathParams["id"]) => [{
  url: '/api/v1/prompt-configurations/:id',
  params: {
    id: id
  }
}] as const;
export type PromptConfigurationsControllerFindOneQueryKey = ReturnType<typeof promptConfigurationsControllerFindOneQueryKey>;
export function promptConfigurationsControllerFindOneQueryOptions(id: PromptConfigurationsControllerFindOnePathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = promptConfigurationsControllerFindOneQueryKey(id);
  return queryOptions<PromptConfigurationsControllerFindOneQueryResponse, ResponseErrorConfig<PromptConfigurationsControllerFindOne401 | PromptConfigurationsControllerFindOne403 | PromptConfigurationsControllerFindOne404>, PromptConfigurationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return promptConfigurationsControllerFindOne(id, config);
    }
  });
}

/**
 * @summary Get a prompt configuration by ID
 * {@link /api/v1/prompt-configurations/:id}
 */
export function usePromptConfigurationsControllerFindOne<TData = PromptConfigurationsControllerFindOneQueryResponse, TQueryData = PromptConfigurationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = PromptConfigurationsControllerFindOneQueryKey>(id: PromptConfigurationsControllerFindOnePathParams["id"], options: {
  query?: Partial<QueryObserverOptions<PromptConfigurationsControllerFindOneQueryResponse, ResponseErrorConfig<PromptConfigurationsControllerFindOne401 | PromptConfigurationsControllerFindOne403 | PromptConfigurationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? promptConfigurationsControllerFindOneQueryKey(id);
  const query = useQuery({
    ...promptConfigurationsControllerFindOneQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PromptConfigurationsControllerFindOne401 | PromptConfigurationsControllerFindOne403 | PromptConfigurationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}